export const ALERT_DRAWER_HEADING = 'Notifications';

export const NO_ENTRIES_TEXT = 'There are currently no notifications!';
export const CLOSE = 'Close';

// Tab identifiers / labels for the notifications drawer
export const TAB_GLOBAL = 'global';
export const TAB_POINTS = 'points';
export const TAB_GLOBAL_LABEL = 'Global';
export const TAB_POINTS_LABEL = 'No Clear Image';

// Alert type that flags a points entry whose photo captured no clear subject
export const POINT_NO_CLEAR_SUBJECT = 'POINT_NO_CLEAR_SUBJECT';

// Feature flag: the "No Clear Image" alerts tab is hidden for now so users only
// see the Global view, and the header badge counts global alerts only. Flip to
// true to bring both back — all of the underlying logic is kept intact.
export const SHOW_NO_CLEAR_IMAGE_TAB = false;

export const NO_GLOBAL_ENTRIES_TEXT =
  'There are currently no global notifications!';
export const NO_POINTS_ENTRIES_TEXT =
  'There are no points entries with unclear images!';

// Cross-company location access requests get their own tab. It is not an
// alerts tab: the rows come from /accessRequest/*, not the alert feed,
// because they carry actions (approve / decline / cancel / revoke) and a
// resolved one still matters — an APPROVED row is what Revoke acts on.
export const TAB_ACCESS = 'access';
export const TAB_ACCESS_LABEL = 'Access Requests';
export const NO_ACCESS_ENTRIES_TEXT = 'No location access requests right now.';

// Who may touch /accessRequest/* at all. The endpoints are owner-tier and
// answer everyone else with HTTP 403 — which AuthUtil turns into a LOGOUT.
// So this is not a cosmetic tab gate: an employee or supervisor whose bell
// polls these endpoints is signed out every 30 seconds. Nothing in the
// access-request feature may be fetched or rendered without passing here.
export const ACCESS_REQUEST_ROLES = [
  'ROLE_OWNER',
  'ROLE_MASTER_ADMIN',
  'ROLE_TECH_ADMIN',
];

export const canSeeAccessRequests = (user) => {
  if (!user) return false;
  const roles = user.authority || [];
  return (
    Boolean(user.isOwner) || ACCESS_REQUEST_ROLES.some((r) => roles.includes(r))
  );
};
